import { injectable } from "tsyringe";
import { PrintReceiptApiRepository } from "@/app/infrastructures/repositories/api/PrintReceiptApiRepository";
import { ListInvoiceApiRequest } from "@/data/payload/api/PrintReceiptRequest";
import { PrintReceiptListInvoice } from "@/domain/entities/PrintReceipt";
import {
  CreateInvoiceApiRequest,
  CreateInvoiceDetailBillApiRequest,
  ListBookingHistoryDetailApiRequest,
  SettlementInvoiceRequest,
  DraftPreviewForUpdateRequest,
  UpdateInvoiceRequest,
  ActivityRequest
} from "@/data/payload/api/PrintReceiptApiRequest";
import {AddDraftReceiptApiRequest} from "@/data/payload/api/AddDraftReceiptApiRequest";

@injectable()
export class PrintReceiptPresenter {
  private repository: PrintReceiptApiRepository;

  constructor(repository: PrintReceiptApiRepository) {
    this.repository = repository;
  }

  public create(payload: CreateInvoiceApiRequest) {
    return this.repository.create(payload);
  }

  public createInvoice(payload: CreateInvoiceDetailBillApiRequest) {
    return this.repository.createInvoice(payload);
  }

  public getListInvoices(
    params: ListInvoiceApiRequest
  ): Promise<PrintReceiptListInvoice> {
    return this.repository.getListInvoices(params);
  }

  public getDetailInvoice(id: number) {
    return this.repository.getDetailInvoice(id);
  }

  public getBookingHistoryDetail(params: ListBookingHistoryDetailApiRequest) {
    return this.repository.getBookingHistoryDetail(params);
  }

  public sendInvoice({
    id,
    dataRequest
  }: {
    id: number;
    dataRequest: FormData;
  }): Promise<any> {
    return this.repository.sendInvoice({ id, dataRequest });
  }

  settlementInvoice(id: number, payload: SettlementInvoiceRequest) {
    return this.repository.settlementInvoice(id, payload);
  }

  public paymentDetailInvoice(id: number) {
    return this.repository.paymentDetailInvoice(id);
  }

  public addDraft(payload: AddDraftReceiptApiRequest) {
    return this.repository.addDraft(payload);
  }

  public getPreview() {
    return this.repository.getPreview();
  }

  public getInvoiceForUpdate(id: number) {
    return this.repository.getInvoiceForUpdate(id);
  }

  public draftPreviewForUpdate(
    id: number,
    payload: DraftPreviewForUpdateRequest
  ) {
    return this.repository.draftPreviewForUpdate(id, payload);
  }

  public updateInvoice(id: number, payload: UpdateInvoiceRequest) {
    return this.repository.updateInvoice(id, payload);
  }

  public activity(id: number, payload: ActivityRequest) {
    return this.repository.activity(id, payload);
  }

  public clearDraftItems() {
    return this.repository.clearDraftItems();
  }
}
